import React from "react";
import { Dialog } from "@mui/material";
import { useIsMobile } from "@/shared/hooks";

interface ResponsiveDialogProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  /**
   * Высота диалога на десктопе (по умолчанию 80vh)
   */
  desktopHeight?: string;
  /**
   * Максимальная ширина диалога
   */
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | false;
  /**
   * Полная ширина
   */
  fullWidth?: boolean;
}

export const ResponsiveDialog: React.FC<ResponsiveDialogProps> = ({
  open,
  onClose,
  children,
  desktopHeight = "80vh",
  maxWidth = "md",
  fullWidth = true,
}) => {
  const isMobile = useIsMobile();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      // Диалог рендерится порталом, но синтетические события React всплывают
      // по дереву компонентов: клик по «Отмена» или по подложке доходил до
      // onClick строки таблицы, из которой диалог открыт, и та открывала
      // свою карточку (возврат платежа из списка платежей, 2026-09-30).
      onClick={(event) => event.stopPropagation()}
      fullScreen={isMobile}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      slotProps={{
        paper: {
          sx: {
            height: isMobile ? "100vh" : desktopHeight,
            display: "flex",
            flexDirection: "column",
            backgroundColor: "background.secondary",
          },
        },
      }}
    >
      {children}
    </Dialog>
  );
};
